import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { BaseEntityReloadResolver2, BaseEntityResolver } from './resolver.helper';
import { State } from '../State';
import { getTextTemplateFetched, getTextTemplateLatestUpdatedAt } from '../State/selectors/text-template.selector';
import { TextTemplateActionTypes } from '../State/actions/text-template.actions';

@Injectable({
    providedIn: 'root',
})
export class TextTemplateResolver extends BaseEntityReloadResolver2 {
    constructor(store: Store<State>) {
        super(getTextTemplateFetched, getTextTemplateLatestUpdatedAt, TextTemplateActionTypes.Load, store);
    }
}
